import type { AxiosResponse } from 'axios';
import { isNil } from 'lodash';
import { router, usePage } from '@inertiajs/vue3';

/**
 * @description 버전 체크
 * 버전이 다르면 새로고침
 * @param response
 */
export const inertiaVersionCheck = (response: AxiosResponse) => {
    const config = response.config;
    let data = response.data;

    const isTextResponse = config.responseType === 'text';
    if (isTextResponse) {
        data = JSON.parse(data);
    }

    const isInertiaResponse = !isNil(data?.props);
    if (isInertiaResponse) {
        const isCheckAssetVersion = data.props.asset_version === usePage().props.asset_version;
        if (!isCheckAssetVersion) {
            const isSamePath = window.location.pathname === data.url;
            if (isSamePath) {
                window.location.reload();
            } else {
                window.location.href = data.url;
            }
        }
    }
};

/**
 * 뒤로가기/앞으로가기 시 서버 재요청을 건너뛸 페이지 컴포넌트 이름 목록.
 * 등록된 컴포넌트는 Inertia 히스토리 캐시를 그대로 사용합니다.
 */
const backCacheComponents = new Set<string>();

export const setBackCacheable = (component: string) => {
    backCacheComponents.add(component);
};

/**
 * 브라우저 history 탐색시 서버에서 데이터 재호출 처리
 * 뒤로가기/앞으로가기 시 브라우저 캐시 대신 서버에서 최신 데이터를 받아옵니다.
 */
export const setupNavigationHandlers = () => {
    let isBackForward = false;

    window.addEventListener('popstate', () => {
        isBackForward = true;
    });

    router.on('navigate', async (event) => {
        if (isBackForward) {
            isBackForward = false;

            // 등록된 컴포넌트는 Inertia 히스토리 캐시를 사용 (서버 재요청 스킵)
            if (backCacheComponents.has(event.detail.page.component)) {
                return;
            }

            // history.state가 null인 경우 스크롤 복원을 비활성화
            const preserveScroll = window.history.state !== null && window.history.state.scrollRegions !== undefined;

            // 뒤로가기/앞으로가기 시 서버에서 데이터를 다시 받아옴
            await router.get(
                event.detail.page.url,
                {},
                {
                    replace: true,
                    preserveState: false, // 상태를 보존하지 않고 서버에서 새로 받아옴
                    preserveScroll, // history.state가 유효한 경우에만 스크롤 복원
                },
            );
        } else {
            isBackForward = false;
        }
    });
};
